var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vTree',{ref:"tree",staticStyle:{"min-height":"70vh"},attrs:{"data":_vm.getNodes,"render":_vm.renderNode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }